import { BrainstormInput } from "../shared/BrainstormInput";
import { ExampleAnswers } from "./ExampleAnswers";
import { JumpBackIn } from "./jump-back-in/JumpBackIn";

/**
 * Landing page for new brainstorm conversations.
 * Shows the hero text and centered input.
 *
 * UI switching is handled by BrainstormChat based on messages.length.
 * When the user sends a message, messages.length > 0 causes BrainstormChat
 * to render BrainstormConversation instead of this component.
 * URL is updated via history.pushState (not Inertia navigation) so streaming continues.
 */
export function BrainstormLandingPage() {
  return (
    <div className="h-full min-h-0 overflow-y-auto">
      <div className="flex flex-col items-center pt-[20vh] px-4">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-semibold mb-4 text-base-500 tracking-tight font-serif">
            Let's get you{" "}
            <span className="relative inline-block">
              <em className="relative z-10 italic">customers</em>
              <img
                src="/images/wavy-underline.svg"
                alt=""
                className="absolute left-0 -bottom-2 w-full"
                style={{ height: "8px" }}
              />
            </span>
          </h1>
          <p
            className="text-lg text-base-400 opacity-70 mx-auto leading-relaxed font-sans"
            style={{ maxWidth: "616px" }}
          >
            Describe your business and marketing goals. We build your landing page, Google Ads,
            and tracking — and connect them automatically.
          </p>
        </div>
        <div className="w-full max-w-3xl mx-auto">
          <BrainstormInput maxRows={12} />
          <ExampleAnswers />
        </div>
        <JumpBackIn />
      </div>
    </div>
  );
}
